import { create } from 'zustand';

import { Platform } from '@/data/models/platform.interface';
import { ResourceFilters } from '@/data/models/resource.interface';
import { Tenant } from '@/data/models/tenant.interface';

interface ResourcesSelectionState {
  prefilledPlatform: Platform | null;
  prefilledTenant: Tenant | null;
  prefilledFilters: ResourceFilters | null;
  prefilledResourcePlatform: string | null;
  currentPlatform: Platform | null;
  currentTenant: Tenant | null;
  currentFilters: ResourceFilters | null;
  currentResourcePlatform: string | null;
  setPrefilledSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _filters: ResourceFilters | null,
  ) => void;
  setPrefilledResourcePlatform: (_platform: string | null) => void;
  clearPrefilledSelection: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _filters: ResourceFilters | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const useResourcesSelectionStore = create<ResourcesSelectionState>((set) => ({
  prefilledPlatform: null,
  prefilledTenant: null,
  prefilledFilters: null,
  prefilledResourcePlatform: null,
  currentPlatform: null,
  currentTenant: null,
  currentFilters: null,
  currentResourcePlatform: null,

  setPrefilledSelection: (
    platform: Platform | null,
    tenant: Tenant | null,
    filters: ResourceFilters | null,
  ) => {
    set({
      prefilledPlatform: platform,
      prefilledTenant: tenant,
      prefilledFilters: filters,
    });
  },

  setPrefilledResourcePlatform: (platform: string | null) => {
    set({ prefilledResourcePlatform: platform });
  },

  clearPrefilledSelection: () => {
    set({
      prefilledPlatform: null,
      prefilledTenant: null,
      prefilledFilters: null,
      prefilledResourcePlatform: null,
    });
  },

  setCurrentSelection: (
    platform: Platform | null,
    tenant: Tenant | null,
    filters: ResourceFilters | null,
  ) => {
    set({
      currentPlatform: platform,
      currentTenant: tenant,
      currentFilters: filters,
    });
  },

  clearCurrentSelection: () => {
    set({
      currentPlatform: null,
      currentTenant: null,
      currentFilters: null,
      currentResourcePlatform: null,
    });
  },
}));

export default useResourcesSelectionStore;
